module.exports = __webpack_public_path__ + "static/media/shopify9.0de11cfe.png";